import React from 'react';

export default function TrustBanner() {
  return (
    <div className="bg-slate-50 border-y border-slate-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold text-slate-400 uppercase tracking-wider mb-8">
          Escape the big three. Join the modern network.
        </p>
        <div className="flex flex-wrap justify-center items-center gap-12 opacity-50 grayscale">
          {/* Simulated Logos with Text for reliable rendering */}
          <div className="text-2xl font-black tracking-tighter text-slate-800">AT&T</div>
          <div className="text-2xl font-bold italic text-red-600">Verizon</div>
          <div className="text-2xl font-black text-pink-600">T-Mobile</div>
          
          <div className="w-px h-8 bg-slate-300 hidden md:block mx-4"></div>
          
          <div className="text-2xl font-bold text-green-600">Mint Mobile</div>
          <div className="text-2xl font-bold text-blue-500">Visible</div>
        </div>
      </div>
    </div>
  );
}